import { render, staticRenderFns } from "./ProgressPanel.vue?vue&type=template&id=56315378&scoped=true&"
import script from "./ProgressPanel.vue?vue&type=script&lang=js&"
export * from "./ProgressPanel.vue?vue&type=script&lang=js&"
import style0 from "./ProgressPanel.vue?vue&type=style&index=0&id=56315378&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56315378",
  null
  
)

export default component.exports